import { ICellRendererParams } from "ag-grid-community";
import { FC, useState } from "react";
import moment from "moment";
import styles from "components/portfolio/cellRenderer/CompetitorRenderer.module.scss";
import { Tooltip } from "@mui/material";
import { useEffect } from "react";
import { classHOC } from "components/app/ClassWrapper";

const CompetitorRenderer: FC<ICellRendererParams> = ({ data, node }) => {
  const [isOnClient, setIsOnClient] = useState(false);
  const value = data?.competitorDiscoveries;
  let competitorsLength = 0;
  let competitorsValue: any;
  const discoveryRecord: any[] = [];
  if (value) {
    competitorsLength = Object.keys(value).length;
    competitorsValue = Object.keys(value);
    for (const [k, v] of Object.entries(value)) {
      const item = {
        label: k,
        data: v,
      };
      discoveryRecord.push(item);
    }
  }

  useEffect(() => {
    setIsOnClient(true);
  });

  if (!isOnClient || node.rowPinned) {
    return null;
  }

  return (
    <div className={styles.competitorsCell}>
      {competitorsLength > 0 ? (
        <Tooltip
          arrow={true}
          placement="right"
          classes={{
            tooltip: styles.moduleTooltip,
            arrow: styles.tooltipArrow,
          }}
          title={
            <div>
              {discoveryRecord.map((item) =>
                item.data.map((i: any) => (
                  <div
                    className={styles.discoveryItemContainer}
                    key={i.discoveryDate}
                  >
                    {i.discoveryMethod === "A" ? (
                      <div className={styles.singleDiscoveryRecord}>
                        The Competitor flag for <b>{i.competitorName}</b> was denoted automatically.
                      </div>
                    ) : (
                      <div>
                        The Competitor flag for <b>{i.competitorName}</b> was denoted by a user.
                      </div>
                    )}
                    <div className={styles.discoveryRecordDate}>
                      {moment(i.discoveryDate).format("MM/DD/YYYY")}
                    </div>
                  </div>
                ))
              )}
            </div>
          }
        >
          <div className={styles.competitorActive}>
            <p className={styles.competitorFlagValue}>
              <span className={styles.competitorCount}>
                {competitorsLength === 1 ? competitorsValue : `Multiple (${competitorsLength})`}
              </span>
            </p>
            <p className={styles.competitorActiveItems}>
              {discoveryRecord.map((item) => (
                <span
                  className={`${styles.competitorActiveItem} ${styles[item.label.toLowerCase()]}`}
                  key={item.label}
                />
              ))}
            </p>
          </div>
        </Tooltip>
      ) : (
        <span>Unknown</span>
      )}
    </div>
  );
};

export default classHOC(CompetitorRenderer);
